/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Api
 * AccessFlow accessibility platform API
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  ActivityItem,
  BillingRedirect,
  BillingStatus,
  DashboardSummary,
  HealthStatus,
  LegalConsentStatus,
  Scan,
  Site,
  SiteInput,
  SiteUpdate,
  VerificationResult,
  WidgetConfig,
  WidgetConfigUpdate,
} from "./api.schemas";

import { customFetch } from "../custom-fetch";
import type { ErrorType, BodyType } from "../custom-fetch";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(
  query: T,
  queryKey: K,
): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getHealthCheckUrl = () => {
  return `/api/healthz`;
};

/**
 * @summary Health check
 */
export const healthCheck = async (
  options?: RequestInit,
): Promise<HealthStatus> => {
  return customFetch<HealthStatus>(getHealthCheckUrl(), {
    ...options,
    method: "GET",
  });
};

export const getHealthCheckQueryKey = () => {
  return [`/api/healthz`] as const;
};

export const getHealthCheckQueryOptions = <
  TData = Awaited<ReturnType<typeof healthCheck>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getHealthCheckQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof healthCheck>>> = ({
    signal,
  }) => healthCheck({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HealthCheckQueryResult = NonNullable<
  Awaited<ReturnType<typeof healthCheck>>
>;
export type HealthCheckQueryError = ErrorType<unknown>;

/**
 * @summary Health check
 */

export function useHealthCheck<
  TData = Awaited<ReturnType<typeof healthCheck>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHealthCheckQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getListSitesUrl = () => {
  return `/api/sites`;
};

/**
 * @summary List the current user's sites
 */
export const listSites = async (options?: RequestInit): Promise<Site[]> => {
  return customFetch<Site[]>(getListSitesUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListSitesQueryKey = () => {
  return [`/api/sites`] as const;
};

export const getListSitesQueryOptions = <
  TData = Awaited<ReturnType<typeof listSites>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof listSites>>, TError, TData>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListSitesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listSites>>> = ({
    signal,
  }) => listSites({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listSites>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListSitesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSites>>
>;
export type ListSitesQueryError = ErrorType<unknown>;

/**
 * @summary List the current user's sites
 */

export function useListSites<
  TData = Awaited<ReturnType<typeof listSites>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof listSites>>, TError, TData>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListSitesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getCreateSiteUrl = () => {
  return `/api/sites`;
};

/**
 * @summary Add a site
 */
export const createSite = async (
  siteInput: SiteInput,
  options?: RequestInit,
): Promise<Site> => {
  return customFetch<Site>(getCreateSiteUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(siteInput),
  });
};

export const getCreateSiteMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSite>>,
    TError,
    { data: BodyType<SiteInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createSite>>,
  TError,
  { data: BodyType<SiteInput> },
  TContext
> => {
  const mutationKey = ["createSite"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createSite>>,
    { data: BodyType<SiteInput> }
  > = (props) => {
    const { data } = props ?? {};

    return createSite(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateSiteMutationResult = NonNullable<
  Awaited<ReturnType<typeof createSite>>
>;
export type CreateSiteMutationBody = BodyType<SiteInput>;
export type CreateSiteMutationError = ErrorType<unknown>;

/**
 * @summary Add a site
 */
export const useCreateSite = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSite>>,
    TError,
    { data: BodyType<SiteInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createSite>>,
  TError,
  { data: BodyType<SiteInput> },
  TContext
> => {
  return useMutation(getCreateSiteMutationOptions(options));
};

export const getGetSiteUrl = (siteId: number) => {
  return `/api/sites/${siteId}`;
};

/**
 * @summary Get a site
 */
export const getSite = async (
  siteId: number,
  options?: RequestInit,
): Promise<Site> => {
  return customFetch<Site>(getGetSiteUrl(siteId), {
    ...options,
    method: "GET",
  });
};

export const getGetSiteQueryKey = (siteId: number) => {
  return [`/api/sites/${siteId}`] as const;
};

export const getGetSiteQueryOptions = <
  TData = Awaited<ReturnType<typeof getSite>>,
  TError = ErrorType<unknown>,
>(
  siteId: number,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getSite>>, TError, TData>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSiteQueryKey(siteId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSite>>> = ({
    signal,
  }) => getSite(siteId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: siteId !== null && siteId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getSite>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type GetSiteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSite>>
>;
export type GetSiteQueryError = ErrorType<unknown>;

/**
 * @summary Get a site
 */

export function useGetSite<
  TData = Awaited<ReturnType<typeof getSite>>,
  TError = ErrorType<unknown>,
>(
  siteId: number,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getSite>>, TError, TData>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetSiteQueryOptions(siteId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getUpdateSiteUrl = (siteId: number) => {
  return `/api/sites/${siteId}`;
};

/**
 * @summary Update a site
 */
export const updateSite = async (
  siteId: number,
  siteUpdate: SiteUpdate,
  options?: RequestInit,
): Promise<Site> => {
  return customFetch<Site>(getUpdateSiteUrl(siteId), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(siteUpdate),
  });
};

export const getUpdateSiteMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSite>>,
    TError,
    { siteId: number; data: BodyType<SiteUpdate> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateSite>>,
  TError,
  { siteId: number; data: BodyType<SiteUpdate> },
  TContext
> => {
  const mutationKey = ["updateSite"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateSite>>,
    { siteId: number; data: BodyType<SiteUpdate> }
  > = (props) => {
    const { siteId, data } = props ?? {};

    return updateSite(siteId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateSiteMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateSite>>
>;
export type UpdateSiteMutationBody = BodyType<SiteUpdate>;
export type UpdateSiteMutationError = ErrorType<unknown>;

/**
 * @summary Update a site
 */
export const useUpdateSite = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSite>>,
    TError,
    { siteId: number; data: BodyType<SiteUpdate> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateSite>>,
  TError,
  { siteId: number; data: BodyType<SiteUpdate> },
  TContext
> => {
  return useMutation(getUpdateSiteMutationOptions(options));
};

export const getDeleteSiteUrl = (siteId: number) => {
  return `/api/sites/${siteId}`;
};

/**
 * @summary Delete a site
 */
export const deleteSite = async (
  siteId: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteSiteUrl(siteId), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteSiteMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSite>>,
    TError,
    { siteId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteSite>>,
  TError,
  { siteId: number },
  TContext
> => {
  const mutationKey = ["deleteSite"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteSite>>,
    { siteId: number }
  > = (props) => {
    const { siteId } = props ?? {};

    return deleteSite(siteId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteSiteMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteSite>>
>;

export type DeleteSiteMutationError = ErrorType<unknown>;

/**
 * @summary Delete a site
 */
export const useDeleteSite = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSite>>,
    TError,
    { siteId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteSite>>,
  TError,
  { siteId: number },
  TContext
> => {
  return useMutation(getDeleteSiteMutationOptions(options));
};

export const getRotateSiteTokenUrl = (siteId: number) => {
  return `/api/sites/${siteId}/rotate-token`;
};

/**
 * @summary Rotate the site's embed token
 */
export const rotateSiteToken = async (
  siteId: number,
  options?: RequestInit,
): Promise<Site> => {
  return customFetch<Site>(getRotateSiteTokenUrl(siteId), {
    ...options,
    method: "POST",
  });
};

export const getRotateSiteTokenMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rotateSiteToken>>,
    TError,
    { siteId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof rotateSiteToken>>,
  TError,
  { siteId: number },
  TContext
> => {
  const mutationKey = ["rotateSiteToken"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof rotateSiteToken>>,
    { siteId: number }
  > = (props) => {
    const { siteId } = props ?? {};

    return rotateSiteToken(siteId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RotateSiteTokenMutationResult = NonNullable<
  Awaited<ReturnType<typeof rotateSiteToken>>
>;

export type RotateSiteTokenMutationError = ErrorType<unknown>;

/**
 * @summary Rotate the site's embed token
 */
export const useRotateSiteToken = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rotateSiteToken>>,
    TError,
    { siteId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof rotateSiteToken>>,
  TError,
  { siteId: number },
  TContext
> => {
  return useMutation(getRotateSiteTokenMutationOptions(options));
};

export const getVerifySiteInstallUrl = (siteId: number) => {
  return `/api/sites/${siteId}/verify`;
};

/**
 * @summary Check whether the widget is installed and reporting
 */
export const verifySiteInstall = async (
  siteId: number,
  options?: RequestInit,
): Promise<VerificationResult> => {
  return customFetch<VerificationResult>(getVerifySiteInstallUrl(siteId), {
    ...options,
    method: "POST",
  });
};

export const getVerifySiteInstallMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof verifySiteInstall>>,
    TError,
    { siteId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof verifySiteInstall>>,
  TError,
  { siteId: number },
  TContext
> => {
  const mutationKey = ["verifySiteInstall"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof verifySiteInstall>>,
    { siteId: number }
  > = (props) => {
    const { siteId } = props ?? {};

    return verifySiteInstall(siteId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type VerifySiteInstallMutationResult = NonNullable<
  Awaited<ReturnType<typeof verifySiteInstall>>
>;

export type VerifySiteInstallMutationError = ErrorType<unknown>;

/**
 * @summary Check whether the widget is installed and reporting
 */
export const useVerifySiteInstall = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof verifySiteInstall>>,
    TError,
    { siteId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof verifySiteInstall>>,
  TError,
  { siteId: number },
  TContext
> => {
  return useMutation(getVerifySiteInstallMutationOptions(options));
};

export const getGetWidgetConfigUrl = (siteId: number) => {
  return `/api/sites/${siteId}/widget-config`;
};

/**
 * @summary Get the site's widget configuration
 */
export const getWidgetConfig = async (
  siteId: number,
  options?: RequestInit,
): Promise<WidgetConfig> => {
  return customFetch<WidgetConfig>(getGetWidgetConfigUrl(siteId), {
    ...options,
    method: "GET",
  });
};

export const getGetWidgetConfigQueryKey = (siteId: number) => {
  return [`/api/sites/${siteId}/widget-config`] as const;
};

export const getGetWidgetConfigQueryOptions = <
  TData = Awaited<ReturnType<typeof getWidgetConfig>>,
  TError = ErrorType<unknown>,
>(
  siteId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getWidgetConfig>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetWidgetConfigQueryKey(siteId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getWidgetConfig>>> = ({
    signal,
  }) => getWidgetConfig(siteId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: siteId !== null && siteId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getWidgetConfig>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetWidgetConfigQueryResult = NonNullable<
  Awaited<ReturnType<typeof getWidgetConfig>>
>;
export type GetWidgetConfigQueryError = ErrorType<unknown>;

/**
 * @summary Get the site's widget configuration
 */

export function useGetWidgetConfig<
  TData = Awaited<ReturnType<typeof getWidgetConfig>>,
  TError = ErrorType<unknown>,
>(
  siteId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getWidgetConfig>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetWidgetConfigQueryOptions(siteId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getUpdateWidgetConfigUrl = (siteId: number) => {
  return `/api/sites/${siteId}/widget-config`;
};

/**
 * @summary Update the site's widget configuration
 */
export const updateWidgetConfig = async (
  siteId: number,
  widgetConfigUpdate: WidgetConfigUpdate,
  options?: RequestInit,
): Promise<WidgetConfig> => {
  return customFetch<WidgetConfig>(getUpdateWidgetConfigUrl(siteId), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(widgetConfigUpdate),
  });
};

export const getUpdateWidgetConfigMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateWidgetConfig>>,
    TError,
    { siteId: number; data: BodyType<WidgetConfigUpdate> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateWidgetConfig>>,
  TError,
  { siteId: number; data: BodyType<WidgetConfigUpdate> },
  TContext
> => {
  const mutationKey = ["updateWidgetConfig"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateWidgetConfig>>,
    { siteId: number; data: BodyType<WidgetConfigUpdate> }
  > = (props) => {
    const { siteId, data } = props ?? {};

    return updateWidgetConfig(siteId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateWidgetConfigMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateWidgetConfig>>
>;
export type UpdateWidgetConfigMutationBody = BodyType<WidgetConfigUpdate>;
export type UpdateWidgetConfigMutationError = ErrorType<unknown>;

/**
 * @summary Update the site's widget configuration
 */
export const useUpdateWidgetConfig = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateWidgetConfig>>,
    TError,
    { siteId: number; data: BodyType<WidgetConfigUpdate> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateWidgetConfig>>,
  TError,
  { siteId: number; data: BodyType<WidgetConfigUpdate> },
  TContext
> => {
  return useMutation(getUpdateWidgetConfigMutationOptions(options));
};

export const getListScansUrl = (siteId: number) => {
  return `/api/sites/${siteId}/scans`;
};

/**
 * @summary List scan history for a site
 */
export const listScans = async (
  siteId: number,
  options?: RequestInit,
): Promise<Scan[]> => {
  return customFetch<Scan[]>(getListScansUrl(siteId), {
    ...options,
    method: "GET",
  });
};

export const getListScansQueryKey = (siteId: number) => {
  return [`/api/sites/${siteId}/scans`] as const;
};

export const getListScansQueryOptions = <
  TData = Awaited<ReturnType<typeof listScans>>,
  TError = ErrorType<unknown>,
>(
  siteId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listScans>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListScansQueryKey(siteId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listScans>>> = ({
    signal,
  }) => listScans(siteId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: siteId !== null && siteId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof listScans>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type ListScansQueryResult = NonNullable<
  Awaited<ReturnType<typeof listScans>>
>;
export type ListScansQueryError = ErrorType<unknown>;

/**
 * @summary List scan history for a site
 */

export function useListScans<
  TData = Awaited<ReturnType<typeof listScans>>,
  TError = ErrorType<unknown>,
>(
  siteId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listScans>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListScansQueryOptions(siteId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getRunScanUrl = (siteId: number) => {
  return `/api/sites/${siteId}/scans`;
};

/**
 * @summary Run an accessibility scan against the site
 */
export const runScan = async (
  siteId: number,
  options?: RequestInit,
): Promise<Scan> => {
  return customFetch<Scan>(getRunScanUrl(siteId), {
    ...options,
    method: "POST",
  });
};

export const getRunScanMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof runScan>>,
    TError,
    { siteId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof runScan>>,
  TError,
  { siteId: number },
  TContext
> => {
  const mutationKey = ["runScan"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof runScan>>,
    { siteId: number }
  > = (props) => {
    const { siteId } = props ?? {};

    return runScan(siteId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RunScanMutationResult = NonNullable<
  Awaited<ReturnType<typeof runScan>>
>;

export type RunScanMutationError = ErrorType<unknown>;

/**
 * @summary Run an accessibility scan against the site
 */
export const useRunScan = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof runScan>>,
    TError,
    { siteId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof runScan>>,
  TError,
  { siteId: number },
  TContext
> => {
  return useMutation(getRunScanMutationOptions(options));
};

export const getGetDashboardSummaryUrl = () => {
  return `/api/dashboard/summary`;
};

/**
 * @summary Aggregate stats across the user's sites
 */
export const getDashboardSummary = async (
  options?: RequestInit,
): Promise<DashboardSummary> => {
  return customFetch<DashboardSummary>(getGetDashboardSummaryUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetDashboardSummaryQueryKey = () => {
  return [`/api/dashboard/summary`] as const;
};

export const getGetDashboardSummaryQueryOptions = <
  TData = Awaited<ReturnType<typeof getDashboardSummary>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getDashboardSummary>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetDashboardSummaryQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDashboardSummary>>
  > = ({ signal }) => getDashboardSummary({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDashboardSummary>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetDashboardSummaryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDashboardSummary>>
>;
export type GetDashboardSummaryQueryError = ErrorType<unknown>;

/**
 * @summary Aggregate stats across the user's sites
 */

export function useGetDashboardSummary<
  TData = Awaited<ReturnType<typeof getDashboardSummary>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getDashboardSummary>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetDashboardSummaryQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetDashboardActivityUrl = () => {
  return `/api/dashboard/activity`;
};

/**
 * @summary Recent activity across the user's sites
 */
export const getDashboardActivity = async (
  options?: RequestInit,
): Promise<ActivityItem[]> => {
  return customFetch<ActivityItem[]>(getGetDashboardActivityUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetDashboardActivityQueryKey = () => {
  return [`/api/dashboard/activity`] as const;
};

export const getGetDashboardActivityQueryOptions = <
  TData = Awaited<ReturnType<typeof getDashboardActivity>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getDashboardActivity>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetDashboardActivityQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDashboardActivity>>
  > = ({ signal }) => getDashboardActivity({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDashboardActivity>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetDashboardActivityQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDashboardActivity>>
>;
export type GetDashboardActivityQueryError = ErrorType<unknown>;

/**
 * @summary Recent activity across the user's sites
 */

export function useGetDashboardActivity<
  TData = Awaited<ReturnType<typeof getDashboardActivity>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getDashboardActivity>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetDashboardActivityQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetBillingStatusUrl = () => {
  return `/api/billing/status`;
};

/**
 * @summary Get the current user's subscription status
 */
export const getBillingStatus = async (
  options?: RequestInit,
): Promise<BillingStatus> => {
  return customFetch<BillingStatus>(getGetBillingStatusUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetBillingStatusQueryKey = () => {
  return [`/api/billing/status`] as const;
};

export const getGetBillingStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof getBillingStatus>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getBillingStatus>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetBillingStatusQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBillingStatus>>
  > = ({ signal }) => getBillingStatus({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getBillingStatus>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetBillingStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBillingStatus>>
>;
export type GetBillingStatusQueryError = ErrorType<unknown>;

/**
 * @summary Get the current user's subscription status
 */

export function useGetBillingStatus<
  TData = Awaited<ReturnType<typeof getBillingStatus>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getBillingStatus>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetBillingStatusQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getCreateBillingCheckoutUrl = () => {
  return `/api/billing/checkout`;
};

/**
 * @summary Start or resume Starter billing
 */
export const createBillingCheckout = async (
  options?: RequestInit,
): Promise<BillingRedirect> => {
  return customFetch<BillingRedirect>(getCreateBillingCheckoutUrl(), {
    ...options,
    method: "POST",
  });
};

export const getCreateBillingCheckoutMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createBillingCheckout>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createBillingCheckout>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["createBillingCheckout"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createBillingCheckout>>,
    void
  > = () => {
    return createBillingCheckout(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateBillingCheckoutMutationResult = NonNullable<
  Awaited<ReturnType<typeof createBillingCheckout>>
>;

export type CreateBillingCheckoutMutationError = ErrorType<unknown>;

/**
 * @summary Start or resume Starter billing
 */
export const useCreateBillingCheckout = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createBillingCheckout>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createBillingCheckout>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getCreateBillingCheckoutMutationOptions(options));
};

export const getCreateBillingPortalUrl = () => {
  return `/api/billing/portal`;
};

/**
 * @summary Open Stripe billing management
 */
export const createBillingPortal = async (
  options?: RequestInit,
): Promise<BillingRedirect> => {
  return customFetch<BillingRedirect>(getCreateBillingPortalUrl(), {
    ...options,
    method: "POST",
  });
};

export const getCreateBillingPortalMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createBillingPortal>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createBillingPortal>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["createBillingPortal"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createBillingPortal>>,
    void
  > = () => {
    return createBillingPortal(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateBillingPortalMutationResult = NonNullable<
  Awaited<ReturnType<typeof createBillingPortal>>
>;

export type CreateBillingPortalMutationError = ErrorType<unknown>;

/**
 * @summary Open Stripe billing management
 */
export const useCreateBillingPortal = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createBillingPortal>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createBillingPortal>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getCreateBillingPortalMutationOptions(options));
};

export const getGetLegalConsentStatusUrl = () => {
  return `/api/legal-consent/status`;
};

/**
 * @summary Check whether the authenticated user accepted the active policies
 */
export const getLegalConsentStatus = async (
  options?: RequestInit,
): Promise<LegalConsentStatus> => {
  return customFetch<LegalConsentStatus>(getGetLegalConsentStatusUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetLegalConsentStatusQueryKey = () => {
  return [`/api/legal-consent/status`] as const;
};

export const getGetLegalConsentStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof getLegalConsentStatus>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getLegalConsentStatus>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetLegalConsentStatusQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getLegalConsentStatus>>
  > = ({ signal }) => getLegalConsentStatus({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getLegalConsentStatus>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetLegalConsentStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof getLegalConsentStatus>>
>;
export type GetLegalConsentStatusQueryError = ErrorType<unknown>;

/**
 * @summary Check whether the authenticated user accepted the active policies
 */

export function useGetLegalConsentStatus<
  TData = Awaited<ReturnType<typeof getLegalConsentStatus>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getLegalConsentStatus>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetLegalConsentStatusQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getAcceptLegalConsentUrl = () => {
  return `/api/legal-consent/accept`;
};

/**
 * @summary Record the authenticated user's acceptance of the active policies
 */
export const acceptLegalConsent = async (
  options?: RequestInit,
): Promise<LegalConsentStatus> => {
  return customFetch<LegalConsentStatus>(getAcceptLegalConsentUrl(), {
    ...options,
    method: "POST",
  });
};

export const getAcceptLegalConsentMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof acceptLegalConsent>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof acceptLegalConsent>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["acceptLegalConsent"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof acceptLegalConsent>>,
    void
  > = () => {
    return acceptLegalConsent(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AcceptLegalConsentMutationResult = NonNullable<
  Awaited<ReturnType<typeof acceptLegalConsent>>
>;

export type AcceptLegalConsentMutationError = ErrorType<unknown>;

/**
 * @summary Record the authenticated user's acceptance of the active policies
 */
export const useAcceptLegalConsent = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof acceptLegalConsent>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof acceptLegalConsent>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getAcceptLegalConsentMutationOptions(options));
};
